import { render, staticRenderFns } from "./RequerimientoObservacion.vue?vue&type=template&id=a7597732&scoped=true&"
import script from "./RequerimientoObservacion.vue?vue&type=script&lang=js&"
export * from "./RequerimientoObservacion.vue?vue&type=script&lang=js&"
import style0 from "./RequerimientoObservacion.vue?vue&type=style&index=0&id=a7597732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7597732",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VFlex,
  VIcon,
  VLayout,
  VTooltip,
})
